import { SVGProps, Ref, forwardRef } from 'react';

export const MediumSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M19.14 1H4.86A3.86 3.86 0 0 0 1 4.86v14.28A3.86 3.86 0 0 0 4.86 23h14.28A3.86 3.86 0 0 0 23 19.14V4.86A3.86 3.86 0 0 0 19.14 1"
            fill="#919191"
        />
        <path
            d="M23 16.14v1.999a4 4 0 0 1-.387.018c-2.362 0-3.691-1.967-3.749-4.429a7 7 0 0 1 .008-.459l.005-.093.008-.097c.085-1.087.434-2.055 1.012-2.77a3.56 3.56 0 0 1 2.804-1.345h.021q.14 0 .278.01v.55a1.3 1.3 0 0 0-.314-.044c-.995.02-1.588 1.213-1.662 2.864H23v.465h-2.02c-.092 1.61.789 2.97 2.02 3.332"
            fill="#E2E2E2"
        />
        <path
            d="m18.963 6.256.018-.004v-.135h-3.543l-3.29 7.732-3.29-7.732H5.04v.135l.017.004c.647.146.975.363.975 1.148v9.19c0 .786-.33 1.004-.976 1.15l-.017.003v.135h2.59v-.134l-.017-.004c-.646-.146-.975-.364-.975-1.149V7.937l4.226 9.945h.24l4.35-10.222v9.162c-.056.62-.382.812-.967.944l-.018.004v.133h4.513v-.133l-.018-.004c-.586-.132-.919-.324-.974-.944l-.003-9.418h.003c0-.785.328-1.002.974-1.148"
            fill="#E2E2E2"
        />
    </svg>
));
MediumSize24Glyph.displayName = 'MediumSize24Glyph';
